import { useAuth } from '../../hooks/auth'
import useSWR from 'swr'
import { getUserFromToken } from '../../utils/getUserFromToken'
import { LOCAL_EXECUTION } from '../../utils/featureFlag'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosError, AxiosResponse } from 'axios'

export interface useUserBankAccountsProps {
  accounts: AxiosResponse<FetchResponse> | undefined
  isLoading: boolean
  isError: AxiosError
  mutate: () => Promise<any> // Adicione mutate ao tipo de retorno
}

interface BankAccount {
  id: number
  nationalRegistration: string
  accountOwner: string
  agency: string
  accountNumber: string
  accountDigit: string
  accountType: string
  accountIdentifier: string
  bank: string
  bankName: string
}

interface FetchResponse {
  success: boolean
  data: BankAccount[]
}

export const useUserBankAccounts = (): useUserBankAccountsProps => {
  const authContext = useAuth()
  const { cookies } = authContext
  const authToken = LOCAL_EXECUTION
    ? process.env.REACT_APP_LOCAL_EXECUTION_TOKEN
    : cookies.userJWT
  const user = getUserFromToken(authToken)

  const url: string = `producer/analytics/getBankAccounts?producerId=${user.id}`

  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading, mutate } = useSWR(url, fetchData)

  return {
    accounts: data,
    isLoading,
    isError: error,
    mutate,
  }
}
